import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Modal from "@mui/material/Modal";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import check from "../../asset/check.png";
import upload from "../../asset/upload.png";
import "../../styles/logo.css";
import { Header } from "../header";
import { Container, Select, MenuItem, FormControl } from "@mui/material";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useTauliah } from "../helpers/state";
import { useLoginStore } from "../helpers/state";
import { usePektaStore } from "../helpers/state";
import PektaHeader from "../helpers/pektaHeader";
import {
  validateFile,
  shortenFilename,
  validationConfigs,
} from "../helpers/fileValidation";

toast.configure();

export function PektaForm3() {
  const { login } = useLoginStore();
  const { tauliah, updateTauliahField } = useTauliah();
  const { nextPage } = usePektaStore();
  const [open, setOpen] = useState(false);

  const isHajiSectionComplete = (() => {
    if (tauliah.hajiStatus === "Telah Menunaikan Haji") {
      return (
        Boolean(tauliah.tahunHaji) &&
        Boolean(tauliah.fileHaji) &&
        Boolean(tauliah.fileMutawif)
      );
    }
    if (tauliah.hajiStatus === "Belum Menunaikan Haji") {
      return Boolean(tauliah.fileMutawif);
    }
    return false;
  })();

  function handleUpload(e) {
    e.preventDefault();
    let todayDate = dayjs(new Date());
    let expDate = tauliah.tarikhAkhir ? dayjs(tauliah.tarikhAkhir) : null;

    // Aggregate validation errors
    const errors = [];
    if (expDate && expDate.isBefore(todayDate)) {
      errors.push("Tarikh Tauliah mengajar negeri sudah tamat tempoh.");
    }
    if (!tauliah.fileTauliah) {
      errors.push("Fail Tauliah diperlukan");
    }
    if (!tauliah.tarikhMula) errors.push("Tarikh Mula Tauliah");
    if (!tauliah.tarikhAkhir) errors.push("Tarikh Akhir Tauliah");
    if (!tauliah.hajiStatus) errors.push("Status Haji");

    if (tauliah.hajiStatus === "Telah Menunaikan Haji") {
      if (!tauliah.tahunHaji) errors.push("Tahun Menunaikan Haji");
      //if (!tauliah.fileHaji) errors.push("Surat Tawaran Haji");
      if (!tauliah.fileMutawif)
        errors.push("Surat Tawaran bertugas sebagai Mutawif");
    } else if (tauliah.hajiStatus === "Belum Menunaikan Haji") {
      if (!tauliah.fileMutawif)
        errors.push("Surat Tawaran bertugas sebagai Mutawif");
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Maklumat wajib belum lengkap",
        html: `<div class="text-left"><ul class="list-disc ml-5 mt-2">${errors
          .map((f) => `<li>${f}</li>`)
          .join("")}</ul></div>`,
      });
      return;
    }

    setOpen(true);

    let finalStart = new Date(tauliah.tarikhMula);
    let finalEnd = new Date(tauliah.tarikhAkhir);
    updateTauliahField("tarikhMula", finalStart);
    updateTauliahField("tarikhAkhir", finalEnd);

    const files = [
      { fieldName: "tauliahID", file: tauliah.fileTauliah },
      // Haji letter only when present
      { fieldName: "hajiID", file: tauliah.fileHaji },
      { fieldName: "spihID", file: tauliah.fileSPIH },
      // Mutawif letter
      { fieldName: "mutawifID", file: tauliah.fileMutawif },
    ];

    const uploadPromises = files
      .filter(({ file }) => file)
      .map(({ fieldName, file }) => {
        let formData = new FormData();
        formData.append("files", file);

        return axios
          .post(`${process.env.REACT_APP_API_URL}/api/upload/`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: function (progressEvent) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`${fieldName} upload progress: ${percentCompleted}%`);
            },
          })
          .then((response) => {
            updateTauliahField(fieldName, response.data[0]?.id);
          })
          .catch((error) => {
            console.error(`Error uploading ${fieldName}:`, error);
            const apiMsg =
              error?.response?.data?.error?.message ||
              error?.response?.data?.message ||
              error?.message ||
              `Gagal memuat naik ${fieldName}. Sila cuba semula.`;
            Swal.fire({
              icon: "error",
              title: "Ralat Muat Naik",
              text: `${apiMsg}`,
            });
          });
      });

    Promise.allSettled(uploadPromises).then((results) => {
      const hasErrors = results.some((result) => result.status === "rejected");
      setOpen(false);
      if (!hasErrors) {
        nextPage(4);
      } else {
        toast.error(
          "Sebahagian dokumen gagal dimuat naik. Sila semak dan cuba lagi.",
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      }
    });
  }

  let navigate = useNavigate();

  useEffect(() => {
    if (
      login.pektaAppStatus !== "rejected" &&
      login.pektaAppStatus !== "none"
    ) {
      toast.warning(
        `Anda telah membuat permohonan PEKTA yang kini berstatus: ${login.pektaAppStatus} `,
        { position: toast.POSITION.TOP_CENTER }
      );
      navigate("/myprofile");
    }
  }, [login.pektaAppStatus, navigate, tauliah.Hkutahu]);

  // Using utility functions from fileValidation.js

  return (
    <div className="bg-gray-50 h-screen pb-5">
      <Header />
      <PektaHeader page={"3"} />

      <Container maxWidth={false} disableGutters>
        <div className="bg-white mx-2 sm:mx-16 m-2">
          <div className="mx-2 pt-10 mb-5 md:mb-40 p-2">
            <p className="text-4xl  md:text-left">Muat Naik Dokumen</p>
            {/* Info box per requirements */}
            <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm rounded p-3 my-3">
              {tauliah.hajiStatus === "Telah Menunaikan Haji" ? (
                <span>
                  Status Haji: Telah Menunaikan Haji. Sila muat naik dua
                  dokumen: "Surat Tawaran Haji" (jika ada) dan "Surat Tawaran bertugas
                  sebagai Mutawif".
                </span>
              ) : tauliah.hajiStatus === "Belum Menunaikan Haji" ? (
                <span>
                  Status Haji: Belum Menunaikan Haji. Sila muat naik "Surat
                  Tawaran bertugas sebagai Mutawif" sahaja.
                </span>
              ) : (
                <span>
                  Pilih status Haji untuk melihat keperluan dokumen yang perlu
                  dimuat naik.
                </span>
              )}
            </div>
            <div className="border-2 flex flex-col sm:flex-row p-3">
              {/* Status Icon */}
              <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                <svg
                  className={`fill-current ${tauliah.Hkutahu} w-3 h-3 text-green-600 pointer-events-none`}
                  version="1.1"
                  viewBox="0 0 17 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="none" fillRule="evenodd">
                    <g
                      transform="translate(-9 -11)"
                      fill="#52912C"
                      fillRule="nonzero"
                    >
                      <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                    </g>
                  </g>
                </svg>
              </div>
              <div className="flex flex-col sm:flex-row justify-between w-full">
                <label className="mr-auto mb-2 text-sm sm:mb-0">
                  Tauliah Mengajar Agama Islam Negeri
                  <label className=" text-red-500">*</label>
                </label>
                {/* Negeri Dropdown to the left of Tarikh Mula */}
                <FormControl
                  sx={{ minWidth: 192, mr: 2, mb: { xs: 2, sm: 0 } }}
                >
                  <Select
                    size="small"
                    displayEmpty
                    value={tauliah.tauliahNegeri || ""}
                    onChange={(e) =>
                      updateTauliahField("tauliahNegeri", e.target.value)
                    }
                    MenuProps={{
                      anchorOrigin: { vertical: "bottom", horizontal: "left" },
                      transformOrigin: { vertical: "top", horizontal: "left" },
                    }}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: "#666" }}>Pilih Negeri</span>
                        );
                      }
                      return selected;
                    }}
                  >
                    <MenuItem value="">Pilih Negeri</MenuItem>
                    <MenuItem value="Johor">Johor</MenuItem>
                    <MenuItem value="Kedah">Kedah</MenuItem>
                    <MenuItem value="Kelantan">Kelantan</MenuItem>
                    <MenuItem value="Melaka">Melaka</MenuItem>
                    <MenuItem value="Negeri Sembilan">Negeri Sembilan</MenuItem>
                    <MenuItem value="Pahang">Pahang</MenuItem>
                    <MenuItem value="Perak">Perak</MenuItem>
                    <MenuItem value="Perlis">Perlis</MenuItem>
                    <MenuItem value="Pulau Pinang">Pulau Pinang</MenuItem>
                    <MenuItem value="Sabah">Sabah</MenuItem>
                    <MenuItem value="Sarawak">Sarawak</MenuItem>
                    <MenuItem value="Selangor">Selangor</MenuItem>
                    <MenuItem value="Wilayah Persekutuan Kuala Lumpur">
                      Wilayah Persekutuan Kuala Lumpur
                    </MenuItem>
                    <MenuItem value="Wilayah Persekutuan Labuan">
                      Wilayah Persekutuan Labuan
                    </MenuItem>
                    <MenuItem value="Wilayah Persekutuan Putrajaya">
                      Wilayah Persekutuan Putrajaya
                    </MenuItem>
                    <MenuItem value="Terengganu">Terengganu</MenuItem>
                  </Select>
                </FormControl>
                <DatePicker
                  label={"Tarikh Mula"}
                  sx={{
                    input: { "&::placeholder": { opacity: 1 } },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E5E7EB",
                    },
                    ".MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
                    label: { color: "black" },
                    border: { borderColor: "#E5E7EB" },
                  }}
                  slotProps={{
                    textField: { placeholder: "Tarikh Mula", size: "small" },
                  }}
                  className="MyDatePicker w-40"
                  format="DD-MM-YYYY"
                  value={!tauliah.tarikhMula ? null : dayjs(tauliah.tarikhMula)}
                  onChange={(e) => {
                    updateTauliahField("tarikhMula", e.$d);
                  }}
                  views={["year", "month", "day"]}
                />
                <div className="sm:mt-0 ml-0 my-2 sm:ml-4 ">
                  <DatePicker
                    label={"Tarikh Akhir"}
                    slotProps={{
                      textField: {
                        placeholder: "Tarikh Akhir",
                        size: "small",
                        opacity: 1,
                      },
                    }}
                    sx={{
                      input: { "&::placeholder": { opacity: 1 } },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E5E7EB",
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "8px",
                      },
                      label: { color: "black" },
                      border: { borderColor: "#E5E7EB" },
                    }}
                    className="MyDatePicker w-40"
                    format="DD-MM-YYYY"
                    value={
                      !tauliah.tarikhAkhir ? null : dayjs(tauliah.tarikhAkhir)
                    }
                    onChange={(e) => {
                      updateTauliahField("tarikhAkhir", e.$d);
                    }}
                    views={["year", "month", "day"]}
                  />
                </div>
              </div>
              <div className="ml-0 md:ml-5">
                <div className="flex items-center">
                  <label
                    htmlFor="kutahu"
                    className="w-32 h-10 border-2 pl-1 rounded-lg cursor-pointer flex items-center"
                  >
                    <img
                      className="h-5 w-5 mr-2 mb-1 bg-fixed cursor-pointer"
                      src={tauliah?.Ikutahu || upload}
                      alt="Upload Icon"
                    />
                    {tauliah?.kutahu || "Muat Naik"}
                    <input
                      id="kutahu"
                      className="border-2 hidden"
                      accept="image/*,application/pdf"
                      type={"file"}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const validation = validateFile(
                            file,
                            validationConfigs.default
                          );
                          if (!validation.valid) {
                            Swal.fire({
                              icon: "error",
                              title: "Jenis Fail Tidak Sah",
                              text: validation.message,
                            });
                            e.target.value = ""; // Clear the input
                            return;
                          }

                          const filename = shortenFilename(
                            e.target.value
                              .toString()
                              .split(/(\\|\/)/g)
                              .pop()
                          );
                          const checkValue = check;

                          updateTauliahField("kutahu", filename);
                          updateTauliahField("Hkutahu", "");
                          updateTauliahField("Ikutahu", checkValue);
                          updateTauliahField("fileTauliah", file);
                        }
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>

            {/* Haji section */}
            <div className="border-2 border-t-0 p-3">
              <div className="flex flex-col">
                <div className="flex-1 w-full">
                  {/* Row 1: Tahun Menunaikan Haji [status] [tahun] */}
                  <div className="flex flex-col sm:flex-row justify-between items-center w-full">
                    <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2">
                      <svg
                        className={`fill-current ${
                          isHajiSectionComplete ? "" : "hidden"
                        } w-3 h-3 text-green-600 pointer-events-none`}
                        version="1.1"
                        viewBox="0 0 17 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="none" fillRule="evenodd">
                          <g
                            transform="translate(-9 -11)"
                            fill="#52912C"
                            fillRule="nonzero"
                          >
                            <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                    <label className="mr-auto mb-2 text-sm sm:mb-0">
                      Tahun Menunaikan Haji
                      <label className=" text-red-500">*</label>
                    </label>
                    <div className="flex items-center gap-2">
                      <FormControl sx={{ minWidth: 200 }}>
                        <Select
                          size="small"
                          value={tauliah.hajiStatus || ""}
                          onChange={(e) => {
                            updateTauliahField("hajiStatus", e.target.value);
                            if (e.target.value === "Telah Menunaikan Haji") {
                              updateTauliahField("tahunHaji", "");
                              updateTauliahField("fileHaji", "");
                              updateTauliahField("Haji", "Muat Naik");
                              updateTauliahField("HHaji", "hidden");
                              updateTauliahField("IHaji", upload);
                            } else if (
                              e.target.value === "Belum Menunaikan Haji"
                            ) {
                              // Reset Surat Tawaran Haji data when switching to Belum Menunaikan Haji
                              updateTauliahField("tahunHaji", "");
                              updateTauliahField("fileHaji", null);
                              updateTauliahField("Haji", "Muat Naik");
                              updateTauliahField("HHaji", "hidden");
                              updateTauliahField("IHaji", upload);
                            }
                          }}
                          displayEmpty
                          sx={{
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#E5E7EB",
                            },
                            ".MuiOutlinedInput-notchedOutline": {
                              borderRadius: "8px",
                            },
                            border: { borderColor: "#E5E7EB" },
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span style={{ color: "#666" }}>
                                  Pilih Status
                                </span>
                              );
                            }
                            return selected;
                          }}
                        >
                          <MenuItem value="Telah Menunaikan Haji">
                            Telah Menunaikan Haji
                          </MenuItem>
                          <MenuItem value="Belum Menunaikan Haji">
                            Belum Menunaikan Haji
                          </MenuItem>
                        </Select>
                      </FormControl>

                      {tauliah.hajiStatus !== "Belum Menunaikan Haji" && (
                        <DatePicker
                          label={"Tahun"}
                          disabled={!tauliah.hajiStatus}
                          sx={{
                            input: { "&::placeholder": { opacity: 1 } },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#E5E7EB",
                            },
                            ".MuiOutlinedInput-notchedOutline": {
                              borderRadius: "8px",
                            },
                            label: { color: "black" },
                            border: { borderColor: "#E5E7EB" },
                          }}
                          slotProps={{
                            textField: { placeholder: "Tahun", size: "small" },
                          }}
                          className="MyDatePicker w-40"
                          format="YYYY"
                          maxDate={dayjs()}
                          value={
                            !tauliah.tahunHaji ? null : dayjs(tauliah.tahunHaji)
                          }
                          onChange={(e) => {
                            updateTauliahField("tahunHaji", e.$d);
                          }}
                          views={["year"]}
                        />
                      )}
                    </div>
                  </div>

                  {/* Row 2: Surat Tawaran Haji [Muat Naik] (Only when Telah Menunaikan Haji) */}
                  {tauliah.hajiStatus === "Telah Menunaikan Haji" && (
                    <div className="mt-3 pl-7 flex items-center justify-between w-full">
                      <label className="mr-4 text-sm">
                        Surat Tawaran Haji{" "}
                      </label>
                      <label
                        htmlFor="haji"
                        className={`w-32 h-10 border-2 pl-1 rounded-lg cursor-pointer flex items-center`}
                      >
                        <img
                          className="h-5 w-5 mr-2 mb-1 bg-fixed cursor-pointer"
                          src={tauliah?.IHaji || upload}
                          alt="Upload Icon"
                        />
                        {tauliah?.Haji || "Muat Naik"}
                        <input
                          id="haji"
                          className="border-2 hidden"
                          type={"file"}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const validation = validateFile(
                                file,
                                validationConfigs.default
                              );
                              if (!validation.valid) {
                                Swal.fire({
                                  icon: "error",
                                  title: "Jenis Fail Tidak Sah",
                                  text: validation.message,
                                });
                                e.target.value = ""; // Clear the input
                                return;
                              }

                              const filename = shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              );
                              const checkValue = check;

                              updateTauliahField("Haji", filename);
                              updateTauliahField("HHaji", "");
                              updateTauliahField("IHaji", checkValue);
                              updateTauliahField("fileHaji", file);
                            }
                          }}
                        />
                      </label>
                    </div>
                  )}

                  {/* Row 3: Surat Tawaran bertugas sebagai Mutawif [Muat Naik] (Shown when any status selected) */}
                  {tauliah.hajiStatus && (
                    <div className="mt-3 pl-7 flex items-center justify-between w-full">
                      <label className="mr-4 text-sm">
                        Surat Tawaran bertugas sebagai Mutawif{" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <label
                        htmlFor="mutawif"
                        className={`w-32 h-10 border-2 pl-1 rounded-lg cursor-pointer flex items-center`}
                      >
                        <img
                          className="h-5 w-5 mr-2 mb-1 bg-fixed cursor-pointer"
                          src={tauliah?.IMutawif || upload}
                          alt="Upload Icon"
                        />
                        {tauliah?.Mutawif || "Muat Naik"}
                        <input
                          id="mutawif"
                          className="border-2 hidden"
                          accept="image/*,application/pdf"
                          type="file"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const validation = validateFile(
                                file,
                                validationConfigs.default
                              );
                              if (!validation.valid) {
                                Swal.fire({
                                  icon: "error",
                                  title: "Jenis Fail Tidak Sah",
                                  text: validation.message,
                                });
                                e.target.value = ""; // Clear the input
                                return;
                              }

                              const filename = shortenFilename(
                                e.target.value
                                  .toString()
                                  .split(/(\\|\/)/g)
                                  .pop()
                              );
                              const checkValue = check;

                              updateTauliahField("Mutawif", filename);
                              updateTauliahField("HMutawif", "");
                              updateTauliahField("IMutawif", checkValue);
                              updateTauliahField("fileMutawif", file);
                            }
                          }}
                        />
                      </label>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* SPIH section remains */}
            <div className="border-2 border-t-0 flex flex-col sm:flex-row p-3">
              <div className="bg-white border-2 rounded-md border-grey-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mb-2 sm:mr-2 sm:mt-0 sm:mb-0">
                <svg
                  className={`fill-current ${tauliah.HSPIH} w-3 h-3 text-green-600 pointer-events-none`}
                  version="1.1"
                  viewBox="0 0 17 12"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="none" fillRule="evenodd">
                    <g
                      transform="translate(-9 -11)"
                      fill="#52912C"
                      fillRule="nonzero"
                    >
                      <path d="m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z" />
                    </g>
                  </g>
                </svg>
              </div>
              <div className="flex flex-col sm:flex-row justify-between w-full">
                <label className="mr-auto mb-2 text-sm sm:mb-0">
                  Sijil Pembimbing Ibadat Haji (SPIH) / Program Eksekutif
                  Pembimbing Ibadat Haji (EPIH)
                </label>
                <DatePicker
                  label={"Tahun"}
                  sx={{
                    input: { "&::placeholder": { opacity: 1 } },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E5E7EB",
                    },
                    ".MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
                    label: { color: "black" },
                    border: { borderColor: "#E5E7EB" },
                  }}
                  slotProps={{
                    textField: { placeholder: "Tahun", size: "small" },
                  }}
                  className="MyDatePicker w-40"
                  format="YYYY"
                  maxDate={dayjs()}
                  value={!tauliah.tahunSPIH ? null : dayjs(tauliah.tahunSPIH)}
                  onChange={(e) => {
                    updateTauliahField("tahunSPIH", e.$d);
                  }}
                  views={["year"]}
                />
              </div>
              <div className="ml-0 md:ml-5">
                <div className="flex items-center">
                  <label
                    htmlFor="spih"
                    className="w-32 h-10 border-2 pl-1 rounded-lg cursor-pointer flex items-center"
                  >
                    <img
                      className="h-5 w-5 mr-2 mb-1 bg-fixed cursor-pointer"
                      src={tauliah?.ISPIH || upload}
                      alt="Upload Icon"
                    />
                    {tauliah?.SPIH || "Muat Naik"}
                    <input
                      id="spih"
                      className="border-2 hidden"
                      accept="image/*,application/pdf"
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const validation = validateFile(
                            file,
                            validationConfigs.default
                          );
                          if (!validation.valid) {
                            Swal.fire({
                              icon: "error",
                              title: "Jenis Fail Tidak Sah",
                              text: validation.message,
                            });
                            e.target.value = ""; // Clear the input
                            return;
                          }

                          const filename = shortenFilename(
                            e.target.value
                              .toString()
                              .split(/(\\|\/)/g)
                              .pop()
                          );
                          const checkValue = check;

                          updateTauliahField("SPIH", filename);
                          updateTauliahField("HSPIH", "");
                          updateTauliahField("ISPIH", checkValue);
                          updateTauliahField("fileSPIH", file);
                        }
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center sm:mx-24 my-16 px-3 flex justify-between">
            <button
              className="border-2 bg-green-600 text-white rounded-lg p-2"
              onClick={() => {
                nextPage(2);
              }}
            >
              ❮ Kembali
            </button>
            <button
              className="border-2 bg-green-600 text-white rounded-lg p-2 ml-4 mb-2"
              onClick={handleUpload}
            >
              Seterusnya ❯
            </button>
          </div>
        </div>
      </Container>
      <Modal
        open={open}
        onClose={() => console.log("check")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center md:mt-40 lg:mt-48 xl:mt-56">
          <CircularProgress color="success" size={200} />
        </div>
      </Modal>
    </div>
  );
}
